import { render, staticRenderFns } from "./ArticleManage.vue?vue&type=template&id=133064f4&scoped=true&"
import script from "./ArticleManage.vue?vue&type=script&lang=js&"
export * from "./ArticleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133064f4",
  null
  
)

export default component.exports